/**
 * Bill status DTO enum - matches backend API contract
 * Single source of truth for wire format
 */
export enum BillStatusDTO {
  OPEN = 'OPEN',
  PAID = 'PAID',
  OVERDUE = 'OVERDUE',
  IN_PROGRESS = 'IN_PROGRESS',
  ERROR = 'ERROR',
}

/**
 * Type aliases for clear intent in request/response interfaces
 */
export type BillStatusRequest = BillStatusDTO;
export type BillStatusResponse = BillStatusDTO;
